import axios from "@services/axios";
import { apiUrl } from "@utils/configEnv";

/**
 * Loads token to prevent CSRF attacks
 */
export const getCSRFToken = async (): Promise<void> => {
  const url = apiUrl();
  await axios.get(`${url}/csrf-cookie`);
};
